define('Hidden.Template', [
    'SC.Configuration',
    'product_views_option_hidden.tpl',
    'transaction_line_views_hidden_option.tpl',
    'underscore'
], function HiddenTemplate(
    Configuration,
    productViewsOptionHiddenTpl,
    productViewsSelectedOptionHiddenTpl,
    _
) {
    'use strict';

    return {
        mountToApp: function mountToApp() {
            var hiddenTemplateSelector = 'product_views_option_hidden.tpl';
            var hiddenTemplateSelected = 'transaction_line_views_hidden_option.tpl';

            _(Configuration.ItemOptions.optionsConfiguration).each(function forEachOptionConfiguration(optionConfiguration) {
                var templateSelector;
                var templateSelected;

                if (!optionConfiguration) {
                    return;
                }

                templateSelector = optionConfiguration.templateSelector;
                templateSelected = optionConfiguration.templateSelected;
                optionConfiguration.templates = (optionConfiguration.templates || {});

                if (templateSelector === hiddenTemplateSelector) {
                    optionConfiguration.templates.selector = productViewsOptionHiddenTpl;
                }

                if (templateSelected === hiddenTemplateSelected) {
                    optionConfiguration.templates.selected = productViewsSelectedOptionHiddenTpl;
                }
            });
        }
    };
});

